/**
 * Main Flow Container. This will contain all the other container components.
 * This component is mounted at 'transfer/'.
 * If we ever move header/footer to React this is where it should live...
 */

import PropTypes from 'prop-types'

import React from 'react'
import { connect } from '../utils/p2p-connect'
import { withRouter } from 'react-router-dom'
import { triggerExternalHook } from '../actions/Actions'
import { SessionTimer } from '../lazy-components'
import { smallAndBigger } from '../../lib/styles/media-queries'
const glamor = require('glamor')

class Main extends React.Component {
  static propTypes = {
    children: PropTypes.object,
    dispatch: PropTypes.func,
    scrollToTop: PropTypes.bool,
    userAuthState: PropTypes.string,
    env: PropTypes.string,
    isBusinessUser: PropTypes.bool,
  }
  state = {
    navHeight: 120,
  }
  componentDidUpdate() {
    if (this.props.scrollToTop) {
      window.scrollTop = 0
    }
  }

  render() {
    const userAuthState = this.props.userAuthState
    const { navHeight } = this.state

    const businessHeaderTop = glamor.css({
      [smallAndBigger]: {
        marginTop: navHeight - 34,
      },
    })
    return (
      <div
        className={`react-p2p_wrapper ${this.props.isBusinessUser &&
          businessHeaderTop}`}
      >
        {this.props.children}
        {userAuthState === 'LOGGEDIN' && (
          <SessionTimer
            onConfirmOpen={() =>
              this.props.dispatch(
                triggerExternalHook('sessionTimerOverlayRendered')
              )
            }
            extendURL="/myaccount/transfer/extendSession"
            env={this.props.env}
          />
        )}
      </div>
    )
  }
}

Main = connect(({ server = {} }) => ({
  userAuthState: server.userAuthState || '',
  env: server.env,
  isBusinessUser: server.businessAccountInfo.isBusinessUser,
}))(Main)

export default withRouter(Main)
